import React, {useEffect, useRef} from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {useStore} from "../../app/store";
import IcClose from "../icons/IcClose";

const Modal = observer(({className}) => {
    const {modalStore} = useStore();

    const isOpen = modalStore.MODAL_INIT_OPENED.length > 0;

    const handleCloseModal = (idx) => {
        if (modalStore.MODAL_INIT_OPENED[idx]) {
            if (modalStore.MODAL_INIT_OPENED[idx].closeFunc) {
                modalStore.MODAL_INIT_OPENED[idx].closeFunc(modalStore.pop);
            } else {
                modalStore.pop();
            }
        }
    };
    const currentModal = useRef([]);
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape" && isOpen && !modalStore.isOpenChangeName) {
                currentModal.current.map((e, idx) => {
                    if (e && !e.contains(event.target)) {
                        handleCloseModal(idx++);
                    }
                })
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [isOpen]);
    if (!isOpen) {
        return null;
    }
    return (
        <ModalContainerWrapper>
            {
                modalStore.MODAL_INIT_OPENED.length &&
                modalStore.MODAL_INIT_OPENED.map((item, idx) => (
                    <ModalWrapInner key={idx} ref={(el) => currentModal.current[idx] = el}
                                    className={`${item.isFirst ? 'on' : ''}`}>
                        <Dimmer className={className}
                                onClick={() => {
                                    handleCloseModal(idx)
                                }}
                        ></Dimmer>
                        <ModalContainer
                            className={"modal-container"}
                            $width={item.modalProps.width}
                            $height={item.modalProps.height}
                        >
                            <ModalTitleWrap>
                                <h1>
                                    {item.title}
                                </h1>
                                <button onClick={() => {
                                    handleCloseModal(idx)
                                }}>
                                    <IcClose color={"#fff"}/>
                                </button>
                            </ModalTitleWrap>

                            <item.component
                                handleCloseModal={handleCloseModal}
                                modalDepth={idx}
                                modalMutate={item.modalMutate}
                                {...item.modalProps}
                            />
                        </ModalContainer>
                    </ModalWrapInner>
                ))
            }

        </ModalContainerWrapper>
    );
//};
});
const ModalContainerWrapper = styled.div`
    display: block;
`
const ModalContainer = styled.article`
    width: ${(props) => (props.$width ? `${props.$width}px` : "auto")};
    height: ${(props) => (props.$height ? `${props.$height}px` : "auto")};
    border-radius: 12px;
    position: relative;
    overflow: hidden;
    z-index: 110;
`;

const Dimmer = styled.div`
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
`;
const ModalWrapInner = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 800;

    &.on {
        z-index: 1000;
    }
`;


const ModalTitleWrap = styled.div`
    position: relative;
    padding: 0 24px;
    background-color: rgb(36, 36, 36);
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;

    h1 {
        color: #fff;
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: -0.16px;
    }
`;
export const ModalBody = styled.div`
    width: 100%;
    height: calc(100% - 48px);
`;
export default Modal;
